import PropTypes from 'prop-types';

import React, { useEffect, useRef, useState } from 'react';
import Slider from 'react-slick';
import { Box, Typography, Stack } from '@mui/material';
import StarIcon from '@mui/icons-material/Star';
import 'slick-carousel/slick/slick.css';
// eslint-disable-next-line import/no-useless-path-segments
import NoImage from '../../src/assets/Image/NoImage.png';

import 'slick-carousel/slick/slick-theme.css';
import useCloudinary from '../hooks/useCloudinaryImage';
import { useDevice } from '../hooks/useResponsive';

// const reviews = [
//   {
//     name: 'Daniel Ferrari',
//     image: '/assets/images/ReviewCarousal/review1.png',
//     message:
//       "I recently purchased a certified pre-owned vehicle from Focus Motors, and I couldn't be happier with the exceptional service I received.",
//     rate: 5,
//   },
//   {
//     name: 'Emily Watson',
//     // image: 'public/assets/images/Reviews/review4.jpg',
//     message:
//       'Amazing experience! The team at Focus Motors was very helpful and made the buying process smooth and enjoyable.',
//     rate: 5,
//   },
//   {
//     name: 'Michael Brown',
//     image: '/assets/images/ReviewCarousal/review1.png',
//     message:
//       'Professional and trustworthy. I’ll definitely recommend Focus Motors to anyone looking for a reliable car dealer.',
//     rate: 4,
//   },
// ];
ReviewCarousel.propTypes = {
  testimonialList: PropTypes.any,
};

export default function ReviewCarousel({ testimonialList }) {
  const slideRefs = useRef([]);
  const [maxHeight, setMaxHeight] = useState(0);
  const [currentSlide, setCurrentSlide] = useState(0);
  const { isMobile } = useDevice();

  const settings = {
    dots: true,
    infinite: true,
    // loop:true,
    autoplay: true,
    autoplaySpeed: 3000,
    pauseOnHover: true,
    slidesToShow: 4, // keep 3.5 items
    speed: 500,
    arrows: false,

    rtl: false, // force half-card on the right
    afterChange: (index) => setCurrentSlide(index),
    customPaging: (i) => {
      const isActive = i === Math.round(currentSlide);
      return (
        <button type="button">
          <span
            style={{
              display: 'block',
              width: '5px',
              height: '5px',
              borderRadius: '50%',
              backgroundColor: isActive ? '#ffffff' : '#888888',
              transition: 'all 0.3s ease',
              margin: '0 auto',
            }}
          />
        </button>
      );
    },
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 3,
          rtl: true,
        },
      },
      {
        breakpoint: 960,
        settings: {
          slidesToShow: 2,
          rtl: true,
        },
      },
      {
        breakpoint: 426,
        settings: {
          slidesToShow: 1,
          rtl: true,
        },
      },
    ],
  };

  useEffect(() => {
    const heights = slideRefs.current.map((ref) => ref?.offsetHeight || 0);
    const tallest = Math.max(...heights);
    setMaxHeight(tallest);
  }, []);
  // console.log(testimonialList);
  return (
    <Box
      sx={{
        maxWidth: '100%',
        px: { xs: 0, md: 2, lg: '75px' },
        py: isMobile ? 4 : '4rem',
        // '& .slick-dots': {
        //   display: 'flex !important',
        //   justifyContent: 'center',
        //   alignItems: 'center',
        //   gap: '0px',
        //   bottom: '-30px',
        // },
        // '& .slick-dots li': {
        //   margin: '0 !important',
        // },
        // '& .slick-dots li button:before': {
        //   fontSize: '5px',
        //   color: '#888888',
        //   opacity: 1,
        // },
        // '& .slick-dots li.slick-active button:before': {
        //   color: '#ffffff',
        // },
        '& .slick-dots': {
          display: 'flex !important',
          justifyContent: 'center',
          alignItems: 'center',
          gap: '6px',
          bottom: '-30px',
        },
        '& .slick-dots li': {
          margin: '0 !important',
        },
        '& .slick-dots li button': {
          padding: 0,
          width: 'auto',
          height: 'auto',
        },
        '& .slick-dots li button:before': {
          display: 'none', // ✅ Hides Slick's default dot
          content: 'none',
        },
      }}
    >
      <Slider {...settings} className="testimonial-carousal">
        {testimonialList?.map((item, index) => {
          const isGrayscale = !isMobile && index === currentSlide + 1;

          return (
            <Stack
              className={isGrayscale ? 'grayscale-slide' : ''}
              gap={2}
              key={index}
              sx={{
                display: 'flex !important',
                flexDirection: 'row',
                // backgroundColor: '#121212',
                borderRadius: 2,
                height: maxHeight || 'auto',
                px: 2,
                alignItems: 'center',
                // filter: isGrayscale ? 'grayscale(50%)' : 'none',
                // opacity: isGrayscale ? 0.5 : 1,
                transition: 'all 0.3s ease',
                marginRight: '-200px',
              }}
            >
              {/* Image */}
              <Stack
                sx={{
                  height: '100%',
                }}
              >
                <Box
                  component="img"
                  //   src={item?.image ?item.image : '/assets/images/ReviewCarousal/NoImage.png'}
                  src={
                    item?.image?.[0]?.url
                      ? // eslint-disable-next-line react-hooks/rules-of-hooks
                        useCloudinary(item.image[0].url, 'w_400,q_auto,f_auto')
                      : NoImage
                  }
                  alt={item.name}
                  sx={{
                    width: { xs: 125, sm: 140 },
                    height: { xs: '100%', sm: 323 },
                    minHeight: { xs: 188, sm: 323 },
                    borderRadius: '6px',
                    objectFit: 'cover',
                    alignSelf: 'stretch',
                    flex: '0 0 auto',
                  }}
                />
              </Stack>
              {/* Content */}
              <Stack
                flex={1}
                // eslint-disable-next-line no-return-assign
                // ref={(el) => (slideRefs.current[index] = el)}
                className="testimonial-content"
                sx={{
                  height: '100%',
                  // alignSelf: isMobile && 'stretch',
                  justifyContent: 'space-between',
                }}
              >
                <Typography fontWeight={500} fontSize={14} color="#FFFFFFDE" mb={0.2}>
                  {item?.name}
                </Typography>
                <Stack direction="row" spacing={0.5} mb={1}>
                  {[
                    ...Array(
                      Number.isFinite(Number(item?.rate)) && Number(item?.rate) > 0 ? Math.floor(Number(item.rate)) : 0
                    ),
                  ].map((_, i) => (
                    <StarIcon key={i} fontSize="small" sx={{ color: '#FBD562', width: '15px' }} />
                  ))}
                </Stack>
                <Typography fontSize={14} color="#FFFFFF99" lineHeight={1.6}>
                  {item?.message}
                </Typography>
              </Stack>
            </Stack>
          );
        })}{' '}
      </Slider>
    </Box>
  );
}
